import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import { EngineerManual } from '../Main/Help/EngineerManual';
import RecapReport from '../Main/WellWorkflow/RecapReport';
import DispatchTruckTicketPdf from '../Reporting/DispatchTruckTicket';
import ExternalStorageReportPdf from '../Reporting/ExternalStorageReportPdf';
import MudReportPdf from '../Reporting/MudReportPdf';
import OperatorRegionPriceListPdf from '../Reporting/OperatorRegionPriceListPdf';
import ProductInventorySnapshotReportPdf from '../Reporting/ProductInventorySnapshotReportPdf';
import VolumeAccountingReportPdf from '../Reporting/VolumeAccountingReportPdf';
import VolumeAccountingSnapshotReportPdf from '../Reporting/VolumeAccountingSnapshotReportPdf';
import WellCloseReviewPdf from '../Reporting/WellCloseReviewReport';
import WellStoryReport from '../Reporting/WellStoryReport';


@inject('stores')
@observer
class Print extends React.Component<RouteComponentProps> {
    public props: any;

    constructor(props: any) {
        super(props);
    }

    public render() {
        return (
            <div className="Print">
                <Switch>
                    <Route exact={true} path="/print/help/engineermanual" component={EngineerManual} />
                    <Route exact={true} path="/print/well/:wellId/recap" component={RecapReport}/>
                    <Route exact={true} path="/print/well/:wellId/test/:taskId/mudreportpdf" component={MudReportPdf}/>
                    <Route exact={true} path="/print/well/:wellId/test/:taskId/volumeaccountpdf" component={VolumeAccountingReportPdf}/>
                    <Route exact={true} path="/print/well/:wellId/test/:taskId/volumeaccountsnapshotpdf" component={VolumeAccountingSnapshotReportPdf}/>
                    <Route exact={true} path="/print/well/:wellId/test/:taskId/productinventorysnapshotpdf" component={ProductInventorySnapshotReportPdf}/>
                    <Route exact={true} path="/print/well/:wellId/test/:taskId/externalstoragepdf" component={ExternalStorageReportPdf}/>
                    <Route exact={true} path="/print/well/:wellId/test/:taskId/wellstorypdf" component={WellStoryReport} />
                    <Route exact={true} path="/print/well/:wellId/wellclosereviewpdf" component={WellCloseReviewPdf} />
                    <Route exact={true} path="/print/operator/:operatorId/region/:regionId/pricelist" component={OperatorRegionPriceListPdf} />
                    <Route exact={true} path="/print/dispatchtruckticket/:truckId/:type" component={DispatchTruckTicketPdf} />
                </Switch>
            </div>
        );
    }
}

export default withRouter(Print);



// WEBPACK FOOTER //
// ./src/Components/Print/Print.tsx